// Mock data for Protection Guardianship™ website

export const tierData = [
  {
    id: 'tier1',
    tier: 'Tier 1',
    name: 'Protection Clarity Call',
    priceINR: 'Free',
    priceUSD: 'Free',
    duration: '20 minutes',
    hook: 'Know where your family stands — clearly and calmly.',
    sections: [
      {
        title: 'What happens',
        bullets: [
          'Understand family responsibilities & dependencies',
          'Review income stability and risk exposure',
          "Identify what's clear vs assumed",
          'Spot silent gaps families often miss'
        ]
      },
      {
        title: 'What you receive',
        bullets: [
          'A short written Protection Status (Clear / Moderate / Exposed)',
          'Key strengths & blind spots',
          'Direction on what matters next'
        ]
      }
    ],
    cta: 'Start on WhatsApp',
    link: 'https://wa.me/9172096199',
    highlighted: false
  },
  {
    id: 'tier2',
    tier: 'Tier 2',
    name: 'Protection Blueprint™',
    priceINR: '₹4,999',
    priceUSD: '$99',
    duration: '45 Minutes',
    hook: "A clear protection blueprint your family can rely on — even if you're not around.",
    sections: [
      {
        title: 'What happens in the session',
        bullets: [
          'Exact income protection your family actually needs',
          'Existing cover: usable vs misleading',
          'Health protection structure (base + top-up direction)',
          'Priority order for fixing protection gaps'
        ]
      },
      {
        title: 'What you receive',
        bullets: [
          'Written Family Protection Blueprint™',
          'Clear protection numbers & structure',
          'Simple spouse-friendly reference note',
          'Calm next steps (optional, never forced)'
        ]
      }
    ],
    cta: 'Get the Protection Blueprint™',
    link: 'https://rzp.io/rzp/rTrzU8M',
    highlighted: false
  },
  {
    id: 'tier3',
    tier: 'Tier 3',
    name: 'Protection Assurance™',
    priceINR: '₹11,999',
    priceUSD: '$249',
    duration: '45-Minute Structured Verification',
    hook: 'For families who already have policies but want to know if the structure will actually work when needed.',
    sections: [
      {
        title: 'What changes for you',
        bullets: [
          'Assumptions → verified protection reality',
          'Policies → tested structural usability',
          'Uncertainty → an assurance verdict'
        ]
      },
      {
        title: 'What\'s included',
        bullets: [
          '5-Dimension Protection Verification',
          'Policy, Claim & Documentation Review',
          'Structural Risk Notes + Correction Direction'
        ]
      },
      {
        title: 'What you receive',
        bullets: [
          'Protection Assurance Verdict™',
          'Verification Matrix™',
          'Protection Correction Roadmap™'
        ]
      }
    ],
    cta: 'BOOK PROTECTION ASSURANCE™',
    ctaNote: 'Assurance works best after Blueprint.',
    link: 'https://rzp.io/rzp/I2qAj82',
    highlighted: true
  },
  {
    id: 'priority',
    tier: 'Priority',
    name: 'Priority 1:1 Strategy Call — With Joseph',
    priceINR: '₹4,999',
    priceUSD: '$149',
    duration: 'Private Strategy Session',
    hook: 'For families who don\'t want multiple conversations — and prefer to get clarity and direction directly.',
    sections: [
      {
        title: 'Inside this call',
        bullets: [
          'Diagnose your real protection gaps',
          'Understand what actually works vs what only looks covered',
          'Identify hidden risks and weak structures',
          'Get clear direction on what needs to be fixed'
        ]
      },
      {
        title: 'What makes this different',
        bullets: [
          'This is not a general discussion.',
          'This is a decisive session — focused on clarity and action.'
        ]
      }
    ],
    note: '₹4,999 is fully adjusted if you move forward with Protection Assurance™ or Complete Family Protection Charter™ within 72 hours.',
    closingLine: 'One conversation. Clear direction. Faster decisions.',
    cta: 'Book Priority Strategy Session',
    link: 'https://rzp.io/rzp/121prioritycall',
    highlighted: false
  },
  {
    id: 'bundle',
    tier: 'Integrated Engagement',
    name: 'Complete Family Protection Charter™',
    priceINR: '₹39,999',
    priceUSD: '$749',
    duration: 'Blueprint + Verification + Structured Follow-Through',
    headline: 'Everything important — structured, verified, and clearly documented — so your family is never dependent on guesswork or memory.',
    subline: 'Families who want their protection handled properly — once — with full clarity, structure, and continuity.',
    tagline: 'This is not advice. This is your family\'s protection system — structured and ready.',
    sections: [
      {
        title: 'What changes for you',
        bullets: [
          'From confusion → a complete protection system',
          'From scattered policies → one aligned structure',
          'From uncertainty → documented family clarity',
          'From dependency on you → spouse-ready understanding',
          'From reactive decisions → structured, guided execution'
        ]
      },
      {
        title: 'What\'s included (Core Work)',
        bullets: [
          'Protection Blueprint™ (Income + Health Structure Design)',
          'Protection Assurance™ Verification (Full structural validation)',
          'Final Structure Alignment & Decision Guidance',
          'Claim & Crisis Readiness Structuring',
          'Implementation Clarity (what to do, in what order)'
        ]
      },
      {
        title: 'What you receive',
        bullets: [
          'Protection Charter Report™',
          'Family Protection Architecture Map™',
          'Spouse-Friendly Reference Note™',
          'Decision-Ready Action Snapshot™',
          '72-Hour Decision Shield™',
          '12-Month Continuity Support™'
        ]
      }
    ],
    cta: 'Book Complete Family Charter',
    link: 'https://rzp.io/rzp/YftyTmw',
    highlighted: false,
    bestValue: true
  },
  {
    id: 'sovereign',
    tier: 'High Ticket',
    name: 'Family Protection Sovereign™',
    priceINR: null,
    priceUSD: null,
    duration: 'Private Protection Office (12 Months)',
    headline: 'A retained protection office for families who do not want to navigate major protection decisions alone.',
    subline: 'This is not advice. This is delegated protection stewardship.',
    labels: ['Concierge', 'Private', 'Invitation Only'],
    sections: [
      {
        title: 'What changes for you',
        bullets: [
          'You no longer manage protection decisions alone.',
          'One steward oversees life cover, health cover, documentation, and structure',
          'Calm authority during hospitalisation, claims, or disruption',
          'Every major protection decision validated before action',
          'Your family always knows what exists, what matters, and what to do next'
        ]
      },
      {
        title: 'What you receive',
        bullets: [
          'Private Stewardship (Limited Families)',
          'Year-long protection oversight',
          'Context retained — no repeated explanations',
          'Decisions validated before execution',
          'Coordination until key actions are implemented',
          'Alignment across policies, nominees, and documentation'
        ]
      },
      {
        title: 'Priority Intervention',
        bullets: [
          'When life events occur: Hospitalisation — Claim situations — Regulatory or documentation issues',
          'Your family contacts one authority first.',
          'No confusion. No panic.'
        ]
      },
      {
        title: 'Ongoing Sovereign Stewardship',
        bullets: [
          'Private Stewardship Briefings',
          'Quarterly closed-room protection briefings where we review: structural alignment — protection exposure — documentation readiness — changes required next',
          'After each briefing you receive a Personal Action Memo outlining exactly what should change next.'
        ]
      },
      {
        title: 'Included at Sovereign Level',
        bullets: [
          'Single Family Protection Ledger™: A living, private record of policies, nominees, access paths, and critical notes maintained year-round.',
          'Crisis-First Protocol: During hospitalisation, claim escalation, or regulatory disruption, the family contacts us first.',
          'Pre-Decision Validation: Any major protection decision is validated before action.',
          'Spouse / Successor Orientation (Annual): Ensures the family knows exactly what to do during stress.',
          'Annual Sovereign Protection Brief: A private written summary of where the family stands and what matters next.'
        ]
      },
      {
        title: 'Capacity Control',
        bullets: [
          'Family Protection Sovereign™ is strictly invitation-only.',
          'A limited number of families are accepted each year to preserve: judgment — discretion — continuity of context'
        ]
      }
    ],
    cta: 'Apply for Sovereign Stewardship',
    ctaNote: 'Private | Invitation Only',
    link: '/sovereign-application',
    highlighted: false,
    premium: true,
    isInternalLink: true
  }
];

export const trustBadges = [
  '15+ Years in Protection Consulting',
  'MDRT USA Member',
  'Asia Leadership Forum Speaker (Hong Kong)',
  'Leadership Award Winner (Mumbai)'
];

export const deliverables = [
  {
    name: 'Protection Charter Report™',
    description: 'Comprehensive analysis of your protection structure with clear, implementation-ready recommendations.'
  },
  {
    name: 'Protection Map™',
    description: 'Visual overview of your complete family protection architecture.'
  },
  {
    name: 'Spouse-Friendly Reference Note™',
    description: 'Easy-to-understand summary in English + Hindi designed for your partner.'
  },
  {
    name: 'Decision-Ready Snapshot™',
    description: 'Concise action steps ready for immediate implementation.'
  },
  {
    name: '72-Hour Decision Shield™',
    description: 'Protected support window to validate your final decisions before commitment.'
  },
  {
    name: '12-Month Continuity™',
    description: 'Ongoing oversight for one year to ensure your protection structure remains aligned as life changes.'
  }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Start on WhatsApp',
    description: 'Begin with a simple conversation. No forms, no pressure.'
  },
  {
    step: 2,
    title: 'Qualification & Booking',
    description: 'We ensure mutual fit and schedule your session.'
  },
  {
    step: 3,
    title: 'Receive Your Outputs',
    description: 'Get structured deliverables and ongoing support.'
  }
];

export const faqs = [
  {
    question: 'Do you sell insurance policies?',
    answer: 'No. We do not sell any insurance products. Protection Guardianship™ is purely advisory—we help you build clarity, structure, and confidence in your protection decisions. You purchase from insurers directly.'
  },
  {
    question: 'What if I already have insurance policies?',
    answer: 'That\'s common. Most families have policies but lack structure and clarity. We review what you have, identify gaps, and create a coherent protection architecture around your existing coverage.'
  },
  {
    question: 'Is this service for India residents only or NRIs too?',
    answer: 'Both. We serve Indian families globally. NRIs often need specialized guidance due to cross-border considerations, which our Sovereign tier addresses comprehensively.'
  },
  {
    question: 'Do you guarantee claim settlement?',
    answer: 'No advisor can guarantee claims—settlement is subject to insurer terms and policy conditions. What we guarantee is clarity, proper structure, and documentation that maximizes your claim readiness.'
  },
  {
    question: 'What do I receive after the session?',
    answer: 'Depending on your tier, you receive structured deliverables like the Protection Map™, Assurance Report™, and Spouse-Friendly Reference Note™. Everything is documented for your records.'
  },
  {
    question: 'How does annual continuity work?',
    answer: 'Life changes—income, family size, goals. Annual continuity ensures your protection structure evolves with you through yearly reviews, event-based support, and decision validation.'
  },
  {
    question: 'What makes this different from free advice online?',
    answer: 'Free advice is generic and often biased toward selling products. We provide personalized, structured guidance with documented deliverables and accountability—no ulterior motives.'
  },
  {
    question: 'How long before I see the deliverables?',
    answer: 'Most deliverables are shared within 48-72 hours of your session, depending on complexity and tier selected.'
  },
  {
    question: 'Can I upgrade from one tier to another?',
    answer: 'Absolutely. Many families start with Tier 1 (free) and progress based on their comfort and needs. Your previous payments are adjusted when upgrading.'
  },
  {
    question: 'Is my information kept confidential?',
    answer: 'Yes. All client information is strictly confidential and used only for advisory purposes. We never share your data with insurers or third parties without explicit consent.'
  },
  {
    question: 'Why isn\'t this free?',
    answer: 'Because certainty takes structure, preparation, and documented outcomes. Free advice is generic. Here you receive a clear decision path with accountability—without sales pressure.'
  }
];

export const aboutJoseph = {
  name: 'Joseph Timothy',
  title: 'Protection Strategist',
  subtitle: 'Protection Guardianship™ by Overflow Nation',
  credentials: [
    'MDRT USA Member',
    'Asia Leadership Forum Speaker (Hong Kong)',
    'Corporate Leadership Award Winner (Mumbai)',
    '15+ Years in Protection Consulting'
  ],
  bio: 'With over 15 years dedicated to protection consulting, I\'ve guided hundreds of families from confusion to clarity. My approach is simple: understand deeply, advise ethically, and deliver structured outcomes. Protection Guardianship™ was born from a belief that families deserve certainty—not sales pressure.',
  beliefStatement: 'I don\'t manage money. I manage responsibility.',
  philosophy: 'Not selling insurance. Building certainty.'
};
